export const pages = {
	'films': { id: 'films', page: 'filmPage', getter: () => import(/* webpackChunkName: 'filmPage' */ 'components/bolt/filmPage/filmPage') },
	'landing': { id: 'landing', page: 'hub', getter: () => import(/* webpackChunkName: 'hub' */ 'components/bolt/hub/hub') }
};
export const sections = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
